// shop-frontend/src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ShopAuthProvider } from "./context/ShopAuthContext";
import { ShopNotificationsProvider } from "./context/ShopNotificationsContext";
import { ShopMallCartProvider } from "./context/ShopMallCartContext";
import { initSentry } from "./sentry";
import "./index.css";
import "./i18n";

initSentry();

// ✅ CRITICAL: Initialize theme & language BEFORE React renders
(() => {
  try {
    // Read from URL params first (passed from user-frontend), then localStorage
    const params = new URLSearchParams(window.location.search);
    const langFromUrl = params.get("lang");
    const themeFromUrl = params.get("theme");

    if (langFromUrl) {
      localStorage.setItem("userLanguage", langFromUrl);
    }
    if (themeFromUrl) {
      localStorage.setItem("shopTheme", themeFromUrl);
      localStorage.setItem("theme", themeFromUrl);
    }

    const savedTheme = themeFromUrl || localStorage.getItem("shopTheme") || localStorage.getItem("theme") || "dark";
    document.documentElement.setAttribute("data-theme", savedTheme);
    document.body.className = savedTheme === "light" ? "light-theme" : "dark-theme";
  } catch (e) {
    document.documentElement.setAttribute("data-theme", "dark");
    document.body.className = "dark-theme";
  }
})();

// Register push-capable service worker (no caching, just push notifications)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Unregister old killer/cache service workers, then register push-only one
    navigator.serviceWorker.getRegistrations().then(registrations => {
      const promises = registrations
        .filter(r => !r.active || !r.active.scriptURL.includes('push-sw.js'))
        .map(r => r.unregister());
      return Promise.all(promises);
    }).then(() => {
      navigator.serviceWorker.register('/push-sw.js')
        .then(reg => console.log('✅ Push SW registered:', reg.scope))
        .catch(err => console.warn('Push SW registration failed:', err));
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ShopAuthProvider>
        <ShopNotificationsProvider>
          <ShopMallCartProvider>
            <App />
          </ShopMallCartProvider>
        </ShopNotificationsProvider>
      </ShopAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
